import React from "react";
import classNames from "classnames";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";

export const COLORED_BOX_VARIANTS = {
  YELLOW: "yellow",
  GREEN: "green",
  RED: "red"
};

const ColoredBox = ({ children, variant = COLORED_BOX_VARIANTS.YELLOW }) => {
  const isDesktop = useIsDesktop();
  let variantClassName;

  switch (variant) {
    case COLORED_BOX_VARIANTS.YELLOW:
      variantClassName = "border-bottom-yellow-2 bg-yellow-4";
      break;
    case COLORED_BOX_VARIANTS.GREEN:
      variantClassName = "border-bottom-green-2 bg-green-2";
      break;
    default:
      variantClassName = "border-bottom-red-3 bg-red-3";
  }

  return (
    <LandingTypography
      className={classNames("relative rounded-lg border-bottom-1", {
        "p-4": isDesktop,
        "p-3": !isDesktop
      }, variantClassName)}
    >
      {children}
    </LandingTypography>
  );
};

export default ColoredBox;
